import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export type { ThreatAssessment } from "./threat-simulation-types";

export const simulateCompanyThreats = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input) => z.object({
    company: z.string().trim().min(2).max(200),
    domain: z.string().trim().toLowerCase().regex(/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/),
    environment: z.enum(["sandbox", "live"]).default("live"),
  }).parse(input))
  .handler(async ({ data, context }) => {
    const { requireEntitlement } = await import("@/lib/payments/entitlements.server");
    await requireEntitlement({ supabase: context.supabase, userId: context.userId, feature: "ai", environment: data.environment });
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { runThreatAssessment } = await import("./threat-simulation.server");
    return runThreatAssessment({ db: supabaseAdmin, userId: context.userId, company: data.company, domain: data.domain });
  });